import React, { useState } from 'react';
import { LayoutDashboard, Gavel, FileCheck, Users, FileText, ArrowLeft, Upload, X, CheckCircle } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link, useNavigate } from 'react-router-dom';
import { MessageModal } from '../../components/modals/MessageModal';
export function CreateAuctionPage() {
  const navigate = useNavigate();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<{
    name: string;
    category: string;
  }[]>([]);
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/authority'
  }, {
    label: 'Auctions',
    icon: Gavel,
    path: '/authority/auctions',
    badge: '3 Active'
  }, {
    label: 'Compliance',
    icon: FileCheck,
    path: '/authority/compliance'
  }, {
    label: 'Public Listings',
    icon: Users,
    path: '/authority/listings'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/authority/reports'
  }];
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>, category: string) => {
    const files = e.target.files;
    if (files) {
      const newFiles = Array.from(files).map(f => ({
        name: f.name,
        category
      }));
      setUploadedFiles([...uploadedFiles, ...newFiles]);
    }
  };
  const handleRemoveFile = (index: number) => {
    setUploadedFiles(uploadedFiles.filter((_, i) => i !== index));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSuccessModalOpen(true);
  };
  const handleModalClose = () => {
    setIsSuccessModalOpen(false);
    navigate('/authority/auctions');
  };
  return <DashboardLayout title="Auction Management" personaLabel="GOVT AUTHORITY" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="GA" data-id="element-2570">
      <div className="max-w-4xl mx-auto" data-id="element-2571">
        <Link to="/authority/auctions" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#1f2933] mb-6" data-id="element-2572">
          <ArrowLeft className="w-4 h-4" data-id="element-2573" /> Cancel & Back
        </Link>

        <h1 className="text-2xl font-bold mb-8" data-id="element-2574">Create New Auction</h1>

        <form onSubmit={handleSubmit} className="bg-white border border-gray-300 p-8 space-y-8" data-id="element-2575">
          <section data-id="element-2576">
            <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-2577">
              Property Details
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2578">
              <div className="space-y-2" data-id="element-2579">
                <label className="text-sm font-bold text-gray-700" data-id="element-2580">
                  Select Plot *
                </label>
                <select required className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2581">
                  <option value="" data-id="element-2582">Select from inventory...</option>
                  <option data-id="element-2583">GOV-2024-001 - Hinjewadi Phase 3</option>
                  <option data-id="element-2584">GOV-2024-002 - Wagholi</option>
                  <option data-id="element-2585">GOV-2024-003 - Chakan Industrial</option>
                </select>
              </div>
              <div className="space-y-2" data-id="element-2586">
                <label className="text-sm font-bold text-gray-700" data-id="element-2587">
                  Base Price (₹) *
                </label>
                <input type="text" required placeholder="e.g. 1,50,00,000" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2588" />
              </div>
            </div>
          </section>

          <section data-id="element-2589">
            <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-2590">
              Timeline
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2591">
              <div className="space-y-2" data-id="element-2592">
                <label className="text-sm font-bold text-gray-700" data-id="element-2593">
                  Start Date *
                </label>
                <input type="date" required className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2594" />
              </div>
              <div className="space-y-2" data-id="element-2595">
                <label className="text-sm font-bold text-gray-700" data-id="element-2596">
                  End Date *
                </label>
                <input type="date" required className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2597" />
              </div>
            </div>
          </section>

          <section data-id="element-2598">
            <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-2599">
              Auction Documents
            </h2>
            <p className="text-sm text-gray-600 mb-4" data-id="element-2600">
              Upload all required documents for bidders to review before
              participating in the auction.
            </p>

            <div className="space-y-4" data-id="element-2601">
              {/* Title Deed */}
              <div className="border border-gray-200 p-4 bg-gray-50" data-id="element-2602">
                <div className="flex items-center justify-between mb-2" data-id="element-2603">
                  <label className="text-sm font-bold text-gray-700" data-id="element-2604">
                    Title Deed / 7/12 Extract *
                  </label>
                  <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e => handleFileUpload(e, 'Title Deed')} className="hidden" id="title-deed" data-id="element-2605" />
                  <label htmlFor="title-deed" className="flex items-center gap-2 px-3 py-1 bg-white border border-gray-300 text-xs font-bold cursor-pointer hover:bg-gray-50" data-id="element-2606">
                    <Upload className="w-3 h-3" data-id="element-2607" /> Upload
                  </label>
                </div>
                <p className="text-xs text-gray-500" data-id="element-2608">
                  PDF, JPG, PNG (max 10MB)
                </p>
              </div>

              {/* Survey Map */}
              <div className="border border-gray-200 p-4 bg-gray-50" data-id="element-2609">
                <div className="flex items-center justify-between mb-2" data-id="element-2610">
                  <label className="text-sm font-bold text-gray-700" data-id="element-2611">
                    Survey Map / Layout Plan *
                  </label>
                  <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e => handleFileUpload(e, 'Survey Map')} className="hidden" id="survey-map" data-id="element-2612" />
                  <label htmlFor="survey-map" className="flex items-center gap-2 px-3 py-1 bg-white border border-gray-300 text-xs font-bold cursor-pointer hover:bg-gray-50" data-id="element-2613">
                    <Upload className="w-3 h-3" data-id="element-2614" /> Upload
                  </label>
                </div>
                <p className="text-xs text-gray-500" data-id="element-2615">
                  PDF, JPG, PNG (max 10MB)
                </p>
              </div>

              {/* Zoning Certificate */}
              <div className="border border-gray-200 p-4 bg-gray-50" data-id="element-2616">
                <div className="flex items-center justify-between mb-2" data-id="element-2617">
                  <label className="text-sm font-bold text-gray-700" data-id="element-2618">
                    Zoning Certificate
                  </label>
                  <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e => handleFileUpload(e, 'Zoning Certificate')} className="hidden" id="zoning-cert" data-id="element-2619" />
                  <label htmlFor="zoning-cert" className="flex items-center gap-2 px-3 py-1 bg-white border border-gray-300 text-xs font-bold cursor-pointer hover:bg-gray-50" data-id="element-2620">
                    <Upload className="w-3 h-3" data-id="element-2621" /> Upload
                  </label>
                </div>
                <p className="text-xs text-gray-500" data-id="element-2622">
                  PDF, JPG, PNG (max 10MB)
                </p>
              </div>

              {/* Tax Receipts */}
              <div className="border border-gray-200 p-4 bg-gray-50" data-id="element-2623">
                <div className="flex items-center justify-between mb-2" data-id="element-2624">
                  <label className="text-sm font-bold text-gray-700" data-id="element-2625">
                    Property Tax Receipts
                  </label>
                  <input type="file" accept=".pdf,.jpg,.jpeg,.png" multiple onChange={e => handleFileUpload(e, 'Tax Receipts')} className="hidden" id="tax-receipts" data-id="element-2626" />
                  <label htmlFor="tax-receipts" className="flex items-center gap-2 px-3 py-1 bg-white border border-gray-300 text-xs font-bold cursor-pointer hover:bg-gray-50" data-id="element-2627">
                    <Upload className="w-3 h-3" data-id="element-2628" /> Upload
                  </label>
                </div>
                <p className="text-xs text-gray-500" data-id="element-2629">
                  PDF, JPG, PNG (max 10MB each, multiple files allowed)
                </p>
              </div>

              {/* Additional Documents */}
              <div className="border border-gray-200 p-4 bg-gray-50" data-id="element-2630">
                <div className="flex items-center justify-between mb-2" data-id="element-2631">
                  <label className="text-sm font-bold text-gray-700" data-id="element-2632">
                    Additional Documents
                  </label>
                  <input type="file" accept=".pdf,.jpg,.jpeg,.png" multiple onChange={e => handleFileUpload(e, 'Additional')} className="hidden" id="additional-docs" data-id="element-2633" />
                  <label htmlFor="additional-docs" className="flex items-center gap-2 px-3 py-1 bg-white border border-gray-300 text-xs font-bold cursor-pointer hover:bg-gray-50" data-id="element-2634">
                    <Upload className="w-3 h-3" data-id="element-2635" /> Upload
                  </label>
                </div>
                <p className="text-xs text-gray-500" data-id="element-2636">
                  NOC, Encumbrance Certificate, etc.
                </p>
              </div>
            </div>

            {/* Uploaded Files List */}
            {uploadedFiles.length > 0 && <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-2637">
                <h3 className="text-sm font-bold mb-3" data-id="element-2638">
                  Uploaded Documents ({uploadedFiles.length})
                </h3>
                <div className="space-y-2" data-id="element-2639">
                  {uploadedFiles.map((file, i) => <div key={i} className="flex items-center justify-between p-3 bg-green-50 border border-green-200" data-id="element-2640">
                      <div className="flex items-center gap-3" data-id="element-2641">
                        <CheckCircle className="w-4 h-4 text-green-600" data-id="element-2642" />
                        <div data-id="element-2643">
                          <div className="text-sm font-bold" data-id="element-2644">{file.name}</div>
                          <div className="text-xs text-gray-500" data-id="element-2645">
                            {file.category}
                          </div>
                        </div>
                      </div>
                      <button type="button" onClick={() => handleRemoveFile(i)} className="text-gray-400 hover:text-red-600" data-id="element-2646">
                        <X className="w-4 h-4" data-id="element-2647" />
                      </button>
                    </div>)}
                </div>
              </div>}
          </section>

          <section data-id="element-2648">
            <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-2649">
              Requirements
            </h2>
            <div className="space-y-4" data-id="element-2650">
              <label className="flex items-center gap-3" data-id="element-2651">
                <input type="checkbox" className="w-4 h-4 accent-[#1f2933]" defaultChecked data-id="element-2652" />
                <span className="text-sm text-gray-700" data-id="element-2653">
                  Require Bidder KYC Verification
                </span>
              </label>
              <label className="flex items-center gap-3" data-id="element-2654">
                <input type="checkbox" className="w-4 h-4 accent-[#1f2933]" defaultChecked data-id="element-2655" />
                <span className="text-sm text-gray-700" data-id="element-2656">
                  Require Earnest Money Deposit (EMD)
                </span>
              </label>
              <div className="pl-7" data-id="element-2657">
                <input type="text" placeholder="EMD Amount (₹)" className="w-48 p-2 border border-gray-300 bg-gray-50 text-sm focus:outline-none focus:border-gray-500" data-id="element-2658" />
              </div>
            </div>
          </section>

          <div className="pt-6 flex justify-end gap-4 border-t border-gray-200" data-id="element-2659">
            <Link to="/authority/auctions" className="px-6 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-2660">
              Cancel
            </Link>
            <button type="submit" className="px-6 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-2661">
              Publish Auction
            </button>
          </div>
        </form>
      </div>

      <MessageModal isOpen={isSuccessModalOpen} onClose={handleModalClose} title="Auction Published" message="Your auction has been successfully published and is now live. Bidders can start participating immediately." type="success" data-id="element-2662" />
    </DashboardLayout>;
}